export default {
  id: "datalog",
  en: {
    title: "Robot-as-a-Service dashboard"
  },
  ru: {
    title: "Robot-as-a-Service dashboard"
  }
};
